import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { normalizeExternalUrl } from '../util/external-url.util';

@Pipe({ name: 'safeUrl' })
export class SafeUrlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(url: string): SafeResourceUrl {
        const hrefAttr = normalizeExternalUrl(url) || url;
        return this.sanitizer.bypassSecurityTrustResourceUrl(hrefAttr);
    }
}
